function SystemMessage(id, text, reason, createdAt) {
	this.id = id;
	this.text = text;
	this.reason = reason;
	this.createdAt = createdAt;
}

export default SystemMessage;
